import {
  defineComponent,
  reactive,
  watch,
  getCurrentInstance
} from '@vue/composition-api'
import _ from 'lodash'
import CommonTetxEdit from '@/components/CommonTetxEdit'
import OptionSettings from '../../../SurveyDetail/compontents/optionSettings'
const CityTopicEdit = defineComponent({
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  },
  setup(props, context) {
    const { emit } = context
    const state = reactive({
      editItem: _.cloneDeep(props.item) //编辑数据源
    })
    const vm = getCurrentInstance()
    //i18n 国际化
    const tran = function (initParam) {
      return vm?.proxy.$t(initParam) as string
    }
    watch(
      () => state.editItem,
      (val) => {
        emit('changeTopicContent', val)
      },
      {
        deep: true
      }
    )

    const optionSettingItem = reactive({
      item: state.editItem.topicSetting.topicOptionSetting?.[0],
      index: 0
    })

    const changeDivision = (value) => {
      state.editItem.topicSetting.countryTopicOption = value
    }

    return () => {
      //题目选项
      return (
        <div class="topic-edit-content">
          <div class="topic-edit-content-item topic-edit-content-title">
            {!state.editItem.isAddStatus && (
              <div class="topic-edit-content-title-order">
                {!state.editItem.topicSetting.isAllowNull && <i>*</i>}
                {state.editItem.order}.
              </div>
            )}
            <div style={{ width: '100%' }}>
              <CommonTetxEdit
                needDynamicEvent
                initialData={state.editItem.topicName}
                placeholder="城市题目名"
                handleUpdate={(value) => {
                  state.editItem.topicName = value
                }}
              />
            </div>
          </div>
          <div class="topic-edit-content-item">
            <CommonTetxEdit
              needDynamicEvent
              initialData={state.editItem.topicSetting.topicRemark}
              placeholder={tran('survy.plcremark')}
              handleUpdate={(value) => {
                state.editItem.topicSetting.topicRemark = value
              }}
            />
          </div>
          <div class="topic-edit-content-item">
            <el-cascader
              size="small"
              disabled
              value={[]}
              options={[]}></el-cascader>
          </div>
          <div class="topic-edit-content-item">
            <CommonTetxEdit
              needDynamicEvent={true}
              initialData={state.editItem.topicSetting.endword}
              placeholder="城市题提前结束语"
              handleUpdate={(value) => {
                state.editItem.topicSetting.endword = value
              }}
            />
          </div>
          <Portal to="survey-option-settings">
            <OptionSettings
              type={props.item.topicType}
              isCountryTopicOption={true}
              isAllowNull={state.editItem.topicSetting.isAllowNull}
              optionSettingItem={optionSettingItem}
              countryTopicOption={
                state.editItem.topicSetting.countryTopicOption
              }
              onChangeIsAllowNull={(value) => {
                state.editItem.topicSetting.isAllowNull = value
              }}
              onChangeDivision={(value) => changeDivision(value)}
            />
          </Portal>
        </div>
      )
    }
  }
})
export default CityTopicEdit
